export class ContestantImportDetails {
    public Age: number | null;

    public Category: string | null;

    public CategoryGenerated: boolean = false;

    public Race: string | null;

    public RaceGenerated: boolean = false;

    public Group: string | null;

    public GroupGenerated: boolean = false;

    public Team: string | null;

    public TeamGenerated: boolean = false;

    public Gender: string | null;

    public Birthday: string | null;

    public Name: string | null;

    public NationalityID: number | null;

    public InfoMessages: { text: string; values: any }[] = [];

    public ErrorMessages: { text: string; values: any }[] = [];

    public WarningMessages: { text: string; values: any }[] = [];

    public constructor() {
        this.Age = null;
        this.Category = null;
        this.CategoryGenerated = false;
        this.Race = null;
        this.RaceGenerated = false;
        this.Group = null;
        this.GroupGenerated = false;
        this.Team = null;
        this.TeamGenerated = false;
        this.Birthday = null;
        this.Name = null;
        this.Gender = null;
        this.InfoMessages = [];
        this.ErrorMessages = [];
        this.WarningMessages = [];
        this.NationalityID = null;
    }
}
